module.exports = __webpack_public_path__ + "static/popcorn-box-f16f5d64e675baca26519478e88e4961.svg";